import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

const LoadingButton = ({isLoading, type, handleEvent, text, variant, disabled, icon}) => {
  return (
    <Button
      onClick={handleEvent}
      className="rounded-pill mr-1"
      disabled={isLoading || disabled}
      variant={variant || 'light'}
      type={type}
    >
      {isLoading && (
        <Spinner
          className="mr-2"
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      )}
      {
        icon && !isLoading ? (
          <i className="material-icons">{icon}</i> 
        ) : null
      }
      {text}
    </Button>
  )
}

export default LoadingButton;